import { OnboardingDesktop } from "./Dashboard/OnboardingDesktop";
import { DashboardWalkthrough } from "./Dashboard/DashboardWalkthrough";
import { BranchWalkthrough } from "./Setup/BranchWalkthrough";
import { CategoryWalkthrough } from "./Setup/CategoryWalkthrough";
import { ProductWalkthrough } from "./Setup/ProductWalkthrough";
import { BranchProductWalkthrough } from "./Setup/BranchProductWalkthrough";
import { BranchUserWalkthrough } from "./Setup/BranchUserWalkthrough";
import { BranchProductReportWalkthrough } from "./Reports/BranchProductReportWalkthrough";
import { BranchSalesReportWalkthrough } from "./Reports/BranchSalesReportWalkthrough";
import { StartHere } from "./StartHere";
import { EoDReportWalkthrough } from "./Reports/EoDReportWalkthrough";
import { PersonalizationCreate } from "../../../../__business/components/global/API";

import { VM } from "../../../VM";
import { rqx } from "../../../request/API";
import { env } from "../../../Env";
import { ToolContext } from "../../../context/ToolContext";
import { useContext, useEffect } from "react";
import { OnboardingMobile } from "./Dashboard/OnboardingMobile";
import { OrderWalkthrough } from "./Home/OrderWalkthrough";
import { CheckoutWalkthrough } from "./Home/CheckoutWalkthrough";

export const Index = ( )=>{

    const {tool_state, personalization_state} = useContext(ToolContext);
    const {__SESSION} = tool_state
    const {personalization} = personalization_state


    const user_id = parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]);
    const tool_id =  process.env.REACT_APP_TID_BIZ;
    const view = VM()

    const personalizationRead = async() =>{
        let prs = await rqx.get(`<<global>>/${env()}/personalization/read`, {user_id: user_id, tool_id:tool_id, ref:'all'})
        let map_arry = prs.map(v => {return {...v, personalization: JSON.parse(v.personalization)} } );
        personalization.set(map_arry);
    }

    useEffect(() => {
        personalizationRead()
        //eslint-disable-next-line
    }, []);


    const start = (featureName, p_name, setter) =>{
        if (personalization?.data?.find(prs => prs.feature_name === featureName)){
            let prs = personalization?.data?.find(prs => prs.feature_name === featureName).personalization
            if (!prs.find(p=>p.p_name === p_name)){
                setter()
            }
        }else{
            setter()
        }
    }

    const end = async(featureName, p_name) => {
        let newPersonalization = []

        let prs = await rqx.get(`<<global>>/${env()}/personalization/read`, {user_id: user_id, tool_id:tool_id, ref:'all'})

        if (prs.find(prs => prs.feature_name === featureName)){
            let map_arry = prs.map(v => {return {...v, personalization: JSON.parse(v.personalization)} } );
            personalization.set(map_arry)
            newPersonalization = map_arry ? map_arry.find(prs => prs.feature_name === featureName).personalization : []
        }

        const fprs = !newPersonalization.find(p => p.p_name === p_name)? 
            [...newPersonalization, { p_name: p_name, status: 1 }]
        : 
            newPersonalization;

        let body = {
            user_id:parseInt(user_id), 
            tool_id:parseInt(tool_id), 
            feature_name: featureName, 
            personalization: fprs
        };
        await PersonalizationCreate(body)
    }

    if (!personalization.data) return null;

    return(
        <>
            {/* General */}
            <StartHere/>
            {
                view === "" ?
                    <OnboardingDesktop personalization={personalization} pathname={"/"} end={end} start={start} />
                :
                    <OnboardingMobile personalization={personalization} pathname={"/"} end={end} start={start} />
            }

            {/* Dashboard */}
            {view === "" && <DashboardWalkthrough personalization={personalization} pathname={"/"} end={end} start={start}/>}

            {/* Home */}
            <OrderWalkthrough personalization={personalization.data} pathname={"/"} end={end} start={start}/>
            <CheckoutWalkthrough personalization={personalization.data} pathname={"/"} end={end} start={start}/>

            {/* Setup */}
            <BranchWalkthrough personalization={personalization.data} pathname={"/setup/branch/create"} end={end} start={start}/>
            <CategoryWalkthrough personalization={personalization.data} pathname={"/setup/category/create"} end={end} start={start}/>
            <ProductWalkthrough personalization={personalization.data} pathname={"/setup/product/create"} end={end} start={start}/>
            <BranchProductWalkthrough personalization={personalization.data} pathname={"/setup/branch-product/create"} end={end} start={start}/>
            <BranchUserWalkthrough personalization={personalization.data} pathname={"/setup/branch-user/create"} end={end} start={start}/>

            {/* Reports */}
            <BranchProductReportWalkthrough personalization={personalization.data} pathname={"/reports/branch-product"} end={end} start={start}/>
            <BranchSalesReportWalkthrough personalization={personalization.data} pathname={"/reports/branch-sales"} end={end} start={start}/>
            <EoDReportWalkthrough personalization={personalization.data} pathname={"/reports/sales-report"} end={end} start={start}/>
        </>
    )

}